import {
  h,
  defineComponent,
  createApp,
  ref
} from 'vue'
import CTooltip from '@convenia/components/CTooltip'

export default ({
  bindingValue,
  isObject,
  align,
  binding,
  el,
  value
}) => {
  const show = ref(false)
  const hide = ref((bindingValue || {}).hide)
  const tooltipComponent = defineComponent({
    render () {
      return h(CTooltip, {
        show: show.value,
        hide: hide.value,
        dark: binding.modifiers.dark,
        fontSize: (isObject && binding.value.fontSize) || 14,
        maxWidth: (isObject && binding.value.maxWidth) || 200,
        horizontalPadding: (isObject && binding.value.horizontalPadding) || 10,
        target: el,
        arrowSpacing: align === 'center' ? 10 : 15,
        elementSpacing: (isObject && binding.value.elementSpacing) || (binding.arg ?? 5),
        position: (isObject && binding.value.position) || 'top',
        isHTML: (isObject && binding.value.isHTML),
        value,
        align
      })
    }
  })
  const app = createApp(tooltipComponent)
  const container = document.createElement('div')

  const tooltip = app.mount(container)

  return {
    tooltip,
    setShow: (newValue) => { show.value = newValue },
    setHide: (newValue) => { hide.value = newValue },
    appUnmount: () => { app.unmount() }
  }
}
